/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PlayerSummaryRow = {
    playerId: number;
    type: PlayerSummaryRow.type;
    size: PlayerSummaryRow.size;
    value: string;
    updatedAt: string;
    createdAt: string;
};
export namespace PlayerSummaryRow {
    export enum type {
        OFFENSE = 'OFFENSE',
        DEFENSE = 'DEFENSE',
        OTHER = 'OTHER',
        INTEL = 'INTEL',
    }
    export enum size {
        SHORT = 'SHORT',
        MEDIUM = 'MEDIUM',
    }
}

